/*
 * Sanitair Home — header
 * Regelt de zichtbaarheid van het zoekresultatenpaneel, de bediening van de
 * knop "Bekijk assortiment" met bijbehorend categorieënpaneel en de verdeling
 * van de categorieën over de navigatiebalk.
 */
(function () {
  var OPEN_CLASS = 'is-open';

  /* ---------------------------------------------------------------- zoekbalk */

  function initSearch(wrapper) {
    if (wrapper.dataset.shSearchReady) return;
    wrapper.dataset.shSearchReady = 'true';

    wrapper.addEventListener('focusin', function () {
      wrapper.classList.add(OPEN_CLASS);
    });

    wrapper.addEventListener('input', function () {
      wrapper.classList.add(OPEN_CLASS);
    });

    wrapper.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;

      wrapper.classList.remove(OPEN_CLASS);
      var input = wrapper.querySelector('input[type="search"]');
      if (input) input.blur();
    });
  }

  /* ----------------------------------------------------- assortimentspaneel */

  function setAssortment(root, open) {
    var button = root.querySelector('.sh-assortment__button');
    var panel = root.querySelector('.sh-assortment__panel');
    if (!button || !panel) return;

    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      panel.removeAttribute('hidden');
    } else {
      panel.setAttribute('hidden', '');
    }
  }

  function closeAssortment(root) {
    setAssortment(root, false);
  }

  function initAssortment(root) {
    if (root.dataset.shAssortmentReady) return;
    root.dataset.shAssortmentReady = 'true';

    var button = root.querySelector('.sh-assortment__button');
    var panel = root.querySelector('.sh-assortment__panel');
    if (!button || !panel) return;

    button.addEventListener('click', function () {
      setAssortment(root, button.getAttribute('aria-expanded') !== 'true');
    });

    // Openen op hover, met een korte vertraging bij het sluiten zodat de muis
    // van de knop naar het paneel kan bewegen.
    if (window.matchMedia('(hover: hover)').matches) {
      var closeTimer;

      root.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        setAssortment(root, true);
      });

      root.addEventListener('mouseleave', function () {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () {
          closeAssortment(root);
        }, 200);
      });
    }

    // Aanwijzen van een categorie toont de bijbehorende subcategorieën.
    root.querySelectorAll('[data-sh-cat]').forEach(function (cat) {
      var activate = function () {
        var key = cat.getAttribute('data-sh-cat');

        root.querySelectorAll('[data-sh-cat]').forEach(function (other) {
          other.classList.toggle('is-active', other === cat);
        });
        root.querySelectorAll('[data-sh-sub]').forEach(function (sub) {
          sub.classList.toggle('is-active', sub.getAttribute('data-sh-sub') === key);
        });
      };

      cat.addEventListener('mouseenter', activate);
      cat.addEventListener('focus', activate);
    });
  }

  /* -------------------------------------------------- categorieën: overloop */

  /*
   * De navigatiebalk toont zoveel categorieën als er op één regel passen. Wat
   * niet past verhuist naar het paneel "Meer", inclusief de subcategorieën.
   * Zo steekt er nooit een categorie buiten het scherm, op elke schermbreedte.
   */
  function initCatsOverflow(nav) {
    if (nav.dataset.shCatsReady) return;
    nav.dataset.shCatsReady = 'true';

    var list = nav.querySelector('.sh-cats__list');
    var more = nav.querySelector('[data-sh-cats-more]');
    var target = nav.querySelector('[data-sh-cats-more-list]');
    if (!list || !more || !target) return;

    var items = Array.prototype.slice.call(
      list.querySelectorAll('.sh-cats__item:not(.sh-cats__item--more)')
    );
    if (!items.length) return;

    var frame = null;

    // Bouwt één kolom in het paneel "Meer": de categorie als kop met daaronder
    // haar subcategorieën.
    function buildColumn(item) {
      var link = item.querySelector('.sh-cats__link');
      var label = item.querySelector('.sh-cats__link span');
      var column = document.createElement('li');
      var title = document.createElement('a');

      title.className = 'reversed-link';
      title.href = link.getAttribute('href') || '#';
      title.textContent = (label || link).textContent.trim();
      column.appendChild(title);

      var subs = item.querySelectorAll('.sh-cats__subs > li > a');
      if (subs.length) {
        var sublist = document.createElement('ul');
        sublist.setAttribute('role', 'list');

        Array.prototype.forEach.call(subs, function (sub) {
          var row = document.createElement('li');
          var anchor = document.createElement('a');

          anchor.className = 'reversed-link';
          anchor.href = sub.getAttribute('href') || '#';
          anchor.textContent = sub.textContent.trim();
          row.appendChild(anchor);
          sublist.appendChild(row);
        });

        column.appendChild(sublist);
      }

      return column;
    }

    function layout() {
      frame = null;

      // Alles zichtbaar maken om de echte breedtes te kunnen meten.
      items.forEach(function (item) {
        item.hidden = false;
      });
      more.hidden = true;

      var available = nav.clientWidth;
      if (!available) return;

      var widths = items.map(function (item) {
        return item.getBoundingClientRect().width;
      });
      var total = widths.reduce(function (sum, width) {
        return sum + width;
      }, 0);

      // Halve pixel marge voor afrondingsverschillen tussen browsers.
      if (total <= available + 0.5) {
        target.textContent = '';
        return;
      }

      more.hidden = false;
      var reserved = more.getBoundingClientRect().width;
      var used = 0;
      var inline = 0;

      while (inline < items.length && used + widths[inline] + reserved <= available) {
        used += widths[inline];
        inline++;
      }

      // "Meer" zonder inhoud heeft geen zin.
      if (inline >= items.length) inline = items.length - 1;

      target.textContent = '';
      for (var index = inline; index < items.length; index++) {
        items[index].hidden = true;
        target.appendChild(buildColumn(items[index]));
      }

      target.style.columns = String(Math.min(4, Math.max(1, items.length - inline)));
    }

    function schedule() {
      if (frame) return;
      frame = window.requestAnimationFrame(layout);
    }

    // De eerste verdeling direct uitvoeren, zodat er geen sprong te zien is.
    layout();

    var button = more.querySelector('.sh-cats__more');
    if (button) {
      var expose = function (open) {
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
      };

      more.addEventListener('mouseenter', function () { expose(true); });
      more.addEventListener('mouseleave', function () { expose(false); });
      more.addEventListener('focusin', function () { expose(true); });
      more.addEventListener('focusout', function () { expose(false); });
    }

    // De balk zelf meten zou een meetlus geven: de band eromheen is stabiel.
    var band = nav.closest('.sh-navbar');
    if (window.ResizeObserver && band) {
      new window.ResizeObserver(schedule).observe(band);
    }
    window.addEventListener('resize', schedule);

    // Webfonts veranderen de tekstbreedte; opnieuw verdelen zodra ze staan.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(schedule);
    }
  }

  /* -------------------------------------------------------------------- init */

  function init() {
    document.querySelectorAll('[data-sh-search]').forEach(initSearch);
    document.querySelectorAll('[data-sh-assortment]').forEach(initAssortment);
    document.querySelectorAll('[data-sh-cats]').forEach(initCatsOverflow);

    if (document.documentElement.dataset.shHeaderGlobal) return;
    document.documentElement.dataset.shHeaderGlobal = 'true';

    document.addEventListener('pointerdown', function (event) {
      document.querySelectorAll('[data-sh-search].' + OPEN_CLASS).forEach(function (wrapper) {
        if (!wrapper.contains(event.target)) wrapper.classList.remove(OPEN_CLASS);
      });

      document.querySelectorAll('[data-sh-assortment]').forEach(function (root) {
        if (!root.contains(event.target)) closeAssortment(root);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;

      document.querySelectorAll('[data-sh-assortment]').forEach(function (root) {
        var button = root.querySelector('.sh-assortment__button');
        if (button && button.getAttribute('aria-expanded') === 'true') {
          closeAssortment(root);
          button.focus();
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('page:loaded', init);
  document.addEventListener('shopify:section:load', init);
})();
